(self["webpackChunkheyholy_ss_theme"] = self["webpackChunkheyholy_ss_theme"] || []).push([["/assets/ingredients-slider"],{

/***/ "./src/assets/js/ingredients-slider.js":
/*!*********************************************!*\
  !*** ./src/assets/js/ingredients-slider.js ***!
  \*********************************************/
/***/ (() => {

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var IngredientsSlider = /*#__PURE__*/function (_HTMLElement) {
  function IngredientsSlider() {
    var _this;
    _classCallCheck(this, IngredientsSlider);
    _this = _callSuper(this, IngredientsSlider);
    _this.slider = _this.querySelector('.ingredients-slider-main');
    _this.prevArrow = _this.querySelector('.ingredients-slider__arrow-prev');
    _this.nextArrow = _this.querySelector('.ingredients-slider__arrow-next');
    _this.pagination = _this.querySelector('.swiper-pagination');
    _this.swiper = null;
    return _this;
  }
  _inherits(IngredientsSlider, _HTMLElement);
  return _createClass(IngredientsSlider, [{
    key: "init",
    value: function init() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize.bind(this));
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      if (window.innerWidth < 1024) {
        if (!this.swiper) {
          this.initSwiper();
        }
      } else {
        if (this.swiper) {
          this.swiper.destroy();
          this.swiper = null;
        }
      }
    }
  }, {
    key: "initSwiper",
    value: function initSwiper() {
      this.swiper = new Swiper(this.slider, {
        slidesPerView: 1.1,
        spaceBetween: 15,
        loop: false,
        pagination: {
          el: this.pagination,
          clickable: true
        },
        navigation: {
          prevEl: this.prevArrow,
          nextEl: this.nextArrow
        },
        breakpoints: {
          640: {
            slidesPerView: 1.6
          }
        }
      });
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      var _this2 = this;
      if (typeof Swiper !== 'undefined') {
        this.init();
      } else {
        document.addEventListener('DOMContentLoaded', function () {
          var checkSwiper = setInterval(function () {
            if (typeof Swiper !== 'undefined') {
              _this2.init();
              clearInterval(checkSwiper);
            }
          }, 100);
        });
      }
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('ingredients-slider')) {
  customElements.define('ingredients-slider', IngredientsSlider);
}

/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ var __webpack_exports__ = (__webpack_exec__("./src/assets/js/ingredients-slider.js"));
/******/ }
]);